import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  AppBar,
  CardComponent,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  createEmployerGroupData,
  extractOverridesFromTabs,
  formatCustomQueriesTypesAndFeaturesResponseData,
  formatEndDate,
  formatStartDate,
  generateTabs,
  getEmployerGroupsNames,
  getEmployerItem,
  mergeQuickLinks,
  normalizeQuickLinks,
  processNotifications,
} from '../../core-utils/helper-utils/homePageHelper';
import Loader from '../../_components/molecules/Loader';
import { useNavigate } from 'react-router-dom';
import {
  PROFILE,
  SETTINGS,
  TICKET_MANAGEMENT,
  EXPERICENCE_SCREEN,
  HOME_SCREEN,
} from '../../core-utils/routes';
import { useStores } from '../../stores';
import { observer } from 'mobx-react';
import componentConstants from '../../core-utils/messages/componentConstants';
import TabSelection from '../../_components/molecules/TabSelection';
import HomepageTemplate from '../../_components/templates/HomepageTemplate';
import Snackbar from '../../_components/atoms/Snackbar';
import PopUpNotifer from '../../_components/molecules/PopUpNotifier';
import { UserAccessConstants } from '../../core-utils/helper-utils/userAccess';
import { routesInFeatures } from '../../core-utils/routesHelper';
import ComplianceAssurance from '../ComplianceAssurance';
import CareNavigator from '../CareNavigator';
import { formatAllScreens } from '../../core-utils/formatters/UserManagementPageFormatter';
import NotificationTimeLine from '../../_components/molecules/NotificationTimeline';
import { NotificationCardProps } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/NotificationCard';
import HomeQuickLinks, {
  QuickLinkGroup,
  QuickLinkItem,
} from '../../_components/molecules/HomeQuickLinks';
import GroupSelectModal from '../../_components/molecules/GroupSelectModal';
import {
  ComplianceAssuranceType,
  formatComplianceAssuranceData,
} from '../../core-utils/helper-utils/contractAIQHelper';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import ClaimsAIQTab from '../../_components/organisms/ClaimsAIQTab';
import {
  getCohortDetailsDrillDowns,
  getComplianceAssuranceGroups,
  getEmployerGroups,
  getNotifications,
  getQuickLinks,
  getScreenData,
  getTypesAndFeatures,
  updateQuickLinks,
} from '../../core-utils/axios/home/home';
import { useUserAccess } from '../../core-utils/custom-hooks/UserAccess';
import { messages } from '../../core-utils/messages/homepagemessages';
import { TabItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/CustomiseTabs';

export interface AdminPremiumData {
  service_year: number;
  admin_cost: number;
  premium: number;
}
export interface IEmployerGroupResponseData {
  _id: string;
  risk_status: string;
  eg_nid: string[];
  employer_group_name: string[];
  status: string;
  plan_start_month: string;
  plan_end_month: string;
  recent_plan_year: number;
  start_month: string;
  start_year: number;
  end_month: string;
  end_year: number;
  total_enrolles: number;
  pmpm: number;
  total_cost: number;
  organization: string;
  assigned_to: string;
  __v: number;
  last_updated: string;
  sic_code: string;
  industry_type: string;
  state: string;
  admin_and_premium_cost: AdminPremiumData[];
  max_claim_date: string;
  min_claim_date: string;
  max_incurred_date: string;
  min_incurred_date: string;
  TPA?: string;
  PBM?: string;
  stop_loss_carrier?: string;
  consultant?: string;
  network?: string;
  point_solution?: string;
  total_files?: string;
  is_claims_present?: boolean;
  care_navigation_id?: string | undefined;
  network_indicator_list: string[];
  plan_type?: string;
  renewal_month?: string;
  location?: string;
}
export interface EmployerGroupResponseData {
  _id: string;
  risk_status: string;
  eg_nid: string;
  employer_group_name: string;
  status: string;
  plan_start_month: string;
  plan_end_month: string;
  recent_plan_year: number;
  start_month: string;
  start_year: number;
  end_month: string;
  end_year: number;
  total_enrolles: number;
  pmpm: number;
  total_cost: number;
  organization: string;
  assigned_to: string;
  __v: number;
  last_updated: string;
  sic_code: string;
  industry_type: string;
  state: string;
  admin_and_premium_cost: AdminPremiumData[];
  max_claim_date: string;
  min_claim_date: string;
  max_incurred_date: string;
  min_incurred_date: string;
  is_claims_present?: boolean;
  care_navigation_id?: string | undefined;
  network_indicator_list: string[];
}
export interface EmployerSelectedDuration {
  startDate: string;
  endDate: string;
}
export interface HomePageProps {}

const useStyles = makeStyles()({
  root: { display: 'flex', flexDirection: 'column' },
  flex: { display: 'flex', gap: '1rem', width: '100%' },
  flexCol: { flexDirection: 'column' },
  notificationMainContent: {
    height: '550px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
    marginTop: '10px',
  },
});

const HomePage: React.FC<HomePageProps> = observer(() => {
  const {
    loginPageStore,
    employerGroupStore,
    recommendedTabStore,
    customQueriesStore,
    quaterlyReportStore,
    careNavigatorStore,
    userDetailsStore,
    fiscalControlStore,
    cohortDetailsStore,
  } = useStores();

  const { classes } = useStyles();
  const navigate = useNavigate();
  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();
  const { handleEmployerGroupCardClick } = useUserAccess();
  const pageConstants = componentConstants.PAGES.HOME_PAGE;
  const isCareNavigator = loginPageStore.isCareNavigator;

  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  const userAccess = loginPageStore.userResponse;
  const isAdmin = userAccess.role.name;

  const combinedScreens = Array.from(
    new Set([
      ...(userAccess.careNavigationScreens || []),
      ...(userAccess.complianceAssuranceScreens || []),
      ...(userAccess.riskManagementScreens || []),
    ]),
  );

  const [loading, setLoading] = useState(true);
  const [defaultRoute, setDefaultRoute] = useState(EXPERICENCE_SCREEN);
  const [employerGroupList, setEmployerGroupList] = useState<
    IEmployerGroupResponseData[]
  >([]);
  const [selectedTab, setSelectedTab] = useState('Claims AIQ');
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [tabs, setTabs] = useState<string[]>([]);
  const [complianceAssurancesGroups, setComplianceAssuranceGroups] = useState<
    ComplianceAssuranceType[]
  >([]);
  const [notifications, setNotifications] = useState<NotificationCardProps[]>(
    [],
  );
  const [newNotificationCount, setNewNotificationCount] = useState(0);
  const [notificationCursor, setNotificationCursor] = useState<any>(null);
  const [hasMoreNotifications, setHasMoreNotifications] = useState(true);

  const [openModal, setOpenModal] = useState(false);
  const [activeChip, setActiveChip] = useState<number[]>([]);
  const [userLinks, setUserLinks] = useState<QuickLinkGroup[]>([]);
  const [quickLinkModalItems, setQuickLinkModalItems] = useState<TabItem[]>([]);
  const isFetchingMore = useRef(false);

  const handleModalClose = () => setOpenModal(false);

  const handleModalSave = (value: string) => {
    const employer = getEmployerItem(
      employerGroupStore.allEmployerGroupsData,
      value,
    );
    if (!employer) {
      return;
    }

    const updatedEmployer = {
      ...createEmployerGroupData(employer.eg_nid, employer.employer_group_name),
      ...employer,
      eg_nid: [employer.eg_nid],
      employer_group_name: [employer.employer_group_name],
    };

    handleEmployerGroupCardClick(
      updatedEmployer,
      defaultRoute,
      formatStartDate(employer.recent_plan_year, employer.plan_end_month),
      formatEndDate(employer.recent_plan_year, employer.plan_end_month),
    );
  };

  const handleCardClick = (item: QuickLinkItem) => {
    if (isAdmin !== 'super_admin') {
      if (
        !combinedScreens.includes(item.SCREEN_NAME) ||
        item.SCREEN_NAME === ''
      ) {
        openSnackbar(
          `Access to ${item.TITLE} is restricted. Please contact support.`,
          'error',
          5000,
        );
        return;
      }
    }
    if (item.DIRECTLINK) {
      navigate(item.LINK);
      return;
    }
    setOpenModal(true);
    setDefaultRoute(item?.LINK);
  };

  const resetStores = () => {
    employerGroupStore.removeEmployerGroupResponseData();
    employerGroupStore.removeSelectedDuration();
    recommendedTabStore.removeSpecificDeductibleValue();
    quaterlyReportStore.removeTableData();
    quaterlyReportStore.removeDates();
    careNavigatorStore.removeGroupData();
    fiscalControlStore.removeData();
    cohortDetailsStore.removeClaimIdList();
    cohortDetailsStore.removeCohortDetailsList();
    cohortDetailsStore.removeConditionsDetails();
    cohortDetailsStore.removeMemberUniqueIdList();
  };

  const handleUpdateQuickLinks = async () => {
    const overrides = extractOverridesFromTabs(quickLinkModalItems);
    const normalized = normalizeQuickLinks(messages.QUICK_LINKS, [], [], '');
    const merged = mergeQuickLinks(normalized, overrides);

    setUserLinks(merged);
    setQuickLinkModalItems(generateTabs(merged));
    await updateQuickLinks(loginPageStore.userId, overrides);
    openSnackbar('Quick Links updated Successfully', 'success', 3000);
  };

  // Routes functions
  /*
    If Experience route is not accessible by a user, then next followed route will be taken
  */
  const getDefaultRoute = () => {
    for (const route of routesInFeatures) {
      if (loginPageStore.userAccessRoutes.includes(route)) {
        setDefaultRoute(route);
        break;
      }
    }
  };

  const handleLogout = async () => {
    try {
      if (token) {
        axios.get(
          `${properties.userManagementBaseUrl}${properties.users}/logout`,
        );
        localStorage.clear();
        navigate('/login');
      }
    } catch (error) {
       
      console.error('Logout failed:', error);
    }
  };

  const shouldLoadMore = (
    visibleStopIndex: number,
    totalItems: number,
    threshold = 5,
  ) => {
    return visibleStopIndex >= totalItems - threshold;
  };

  const loadMoreNotifications = async () => {
    if (!hasMoreNotifications || !notificationCursor) {
      return;
    }

    if (isFetchingMore.current) {
      return;
    }
    isFetchingMore.current = true;

    try {
      const res = await getNotifications(token, {
        limit: 20,
        cursor: notificationCursor,
      });

      const newData = res.data?.data;
      const nextCursor = res.data?.nextCursor;

      if (!newData?.length) {
        setHasMoreNotifications(false);
        return;
      }

      setNotifications((prev) => [...prev, ...processNotifications(newData)]);

      setNotificationCursor(nextCursor);
      setHasMoreNotifications(Boolean(nextCursor));
    } finally {
      isFetchingMore.current = false;
    }
  };
  const handleItemsRendered = ({
    visibleStopIndex,
  }: {
    visibleStopIndex: number;
  }) => {
    if (
      shouldLoadMore(visibleStopIndex, notifications.length) &&
      hasMoreNotifications
    ) {
      loadMoreNotifications();
    }
  };

  const handleSettings = () => navigate(SETTINGS);
  const handleProfile = () =>
    navigate(PROFILE, { state: { previousRoute: HOME_SCREEN } });
  const handleHelp = () =>
    navigate(TICKET_MANAGEMENT, { state: { previousRoute: HOME_SCREEN } });

  const getHomePageTabs = () => {
    let tabs: string[] = [];
    if (isCareNavigator) {
      tabs.push(pageConstants.TABS[2]);
    } else {
      const userRole = loginPageStore.userResponse.role.name;
      if (userRole === UserAccessConstants.SUPER_ADMIN) {
        tabs = pageConstants.TABS;
      } else {
        if (userDetailsStore.riskManagement) {
          tabs.push(pageConstants.TABS[0]);
        }
        if (userDetailsStore.complianceAssurance) {
          tabs.push(pageConstants.TABS[1]);
        }
        if (userDetailsStore.careNavigation) {
          tabs.push(pageConstants.TABS[2]);
        }
      }
    }
    setTabs(tabs);
  };

  const screenAPICall = async () => {
    const responses = await Promise.allSettled([getScreenData()]);
    if (responses[0]?.status === 'fulfilled') {
      userDetailsStore.setAllScreens(
        formatAllScreens(responses[0].value?.data),
      );
    } else {
      openSnackbar(responses[0]?.reason, 'error', 5000);
    }
  };

  const apiCalls = async () => {
    try {
      setLoading(true);
      setNotificationCursor(null);
      setHasMoreNotifications(true);

      const [
        employerGroupsResponse,
        complianceGroupsResponse,
        notificationsDataResponse,
        typesAndFeaturesResponse,
        quickLinksResponse,
        cohortResponse,
      ] = await Promise.all([
        getEmployerGroups(token),
        getComplianceAssuranceGroups(),
        getNotifications(token, { limit: 20 }),
        getTypesAndFeatures(),
        getQuickLinks(loginPageStore.userId),
        getCohortDetailsDrillDowns(),
      ]);

      const employerGroups = employerGroupsResponse.data?.data;
      const complianceGroups = complianceGroupsResponse.data?.data;
      const notificationsData = notificationsDataResponse.data?.data;
      const nextCursor = notificationsDataResponse.data?.nextCursor;
      const typesAndFeatures = typesAndFeaturesResponse.data?.data;
      const quickLinks = quickLinksResponse.data?.data;
      const cohortData = cohortResponse.data?.data;

      setEmployerGroupList(
        employerGroups.filter(
          (obj: any) =>
            obj.is_claims_present === undefined ||
            obj.is_claims_present !== false,
        ),
      );

      employerGroupStore.setAllEmployerGroupsData(employerGroups);
      setComplianceAssuranceGroups(
        formatComplianceAssuranceData(complianceGroups.groups),
      );
      setNotifications(processNotifications(notificationsData));
      setNotificationCursor(nextCursor);
      setHasMoreNotifications(Boolean(nextCursor));

      const unviewedCount = notificationsData.filter(
        (item: any) => !item.isView,
      ).length;
      setNewNotificationCount(unviewedCount);

      customQueriesStore.setTypesAndFeatues(
        formatCustomQueriesTypesAndFeaturesResponseData(typesAndFeatures),
      );

      const normalized = normalizeQuickLinks(
        messages.QUICK_LINKS,
        messages.HIDDEN_QUICK_LINKS,
        combinedScreens,
        isAdmin,
      );
      const merged = mergeQuickLinks(normalized, quickLinks);
      setUserLinks(merged);
      setQuickLinkModalItems(generateTabs(merged));

      const categoryDropDownOptions: string[] = [];
      const conditionDropDownOptions: string[][] = [];
      const propertyDropDownOptions: string[][] = [];
      const cohortSelectionsTypes: string[] = [];

      cohortData.map((dropDownDetails: any) => {
        categoryDropDownOptions?.push(dropDownDetails?.category);
        conditionDropDownOptions?.push(dropDownDetails?.condition?.split('/'));
        propertyDropDownOptions?.push(dropDownDetails?.values);
        cohortSelectionsTypes?.push(dropDownDetails?.selections);
      });

      cohortDetailsStore.setCohortDetailsDrillDownData(
        categoryDropDownOptions,
        conditionDropDownOptions,
        cohortSelectionsTypes,
        propertyDropDownOptions,
      );
    } catch (error) {
      openSnackbar('An unexpected error occurred: ' + error, 'error', 6000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHomePageTabs();
    screenAPICall();
  }, []);

  useEffect(() => {
    if (tabs.length > 0) {
      setNotificationCursor(null);
      setHasMoreNotifications(true);
      setNotifications([]);
      if (!isCareNavigator) {
        apiCalls();
      } else {
        setLoading(false);
      }
      getDefaultRoute();
      resetStores();
    }
  }, [tabs]);

  useEffect(() => {
    if (tabs.length > 0) {
      setSelectedTab(tabs[selectedTabIndex]);
    }
  }, [tabs, selectedTabIndex]);

  const getContent = () => {
    switch (selectedTab) {
      case 'Claims AIQ':
        return (
          <ClaimsAIQTab
            employerGroupList={employerGroupList}
            setEmployerGroupList={setEmployerGroupList}
            handleEmployerGroupCardClick={handleEmployerGroupCardClick}
            defaultRoute={defaultRoute}
          />
        );
      case 'Contracts AIQ':
        return <ComplianceAssurance />;
      case 'Care Navigation':
        return <CareNavigator />;
      default:
        return <></>;
    }
  };

  const getBodyContent = () => (
    <Box className={`${classes.flex} ${classes.flexCol}`}>
      <Grid className={classes.flex}>
        <CardComponent
          title="Groups"
          body={
            <>
              <TabSelection
                tabList={tabs}
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={setSelectedTabIndex}
                margin="18px 0px 0px 0px"
              />
              {getContent()}
            </>
          }
          mainGridStyles={{ width: '70%', minHeight: '630px' }}
        />
        <NotificationTimeLine
          title="Insights & Notification"
          width="30%"
          newNotificationCount={newNotificationCount}
          notifications={notifications}
          isHomeScreen
          handleItemsRendered={handleItemsRendered}
        />
      </Grid>
      <Grid>
        <HomeQuickLinks
          activeChips={activeChip}
          setActiveChips={setActiveChip}
          handleCardClick={handleCardClick}
          userLinks={userLinks}
          tabs={quickLinkModalItems}
          setTabs={setQuickLinkModalItems}
          handleUpdateQuickLinks={handleUpdateQuickLinks}
        />
      </Grid>
    </Box>
  );

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <HomepageTemplate
          AppBar={
            <>
              <AppBar
                userName={loginPageStore.firstName}
                showSettings={
                  loginPageStore.userResponse.role.name !==
                    UserAccessConstants.USER && !isCareNavigator
                }
                showDropdown={false}
                handleLogout={handleLogout}
                handleSettings={handleSettings}
                showHelp={true}
                handleProfile={handleProfile}
                handleHelp={handleHelp}
              />
              <PopUpNotifer />
            </>
          }
          Body={getBodyContent()}
        />
      )}
      <Snackbar
        {...snackbarState}
        vertical="bottom"
        horizontal="right"
        handleClose={handleCloseSnackBar}
      />
      <GroupSelectModal
        open={openModal}
        handleClose={handleModalClose}
        dropdownOptions={getEmployerGroupsNames(
          employerGroupList,
          complianceAssurancesGroups,
        )}
        handleSave={handleModalSave}
        getDefaultRoute={getDefaultRoute}
      />
    </>
  );
});

export default HomePage;
